<template>
  <v-layout row wrap>
    <v-flex xs12 md6 :key="index" v-for="(rec, index) in recommendations">
      <Recommendation
        v-on:add-score="$emit('add-score', $event)"
        v-on:go-ranking="$emit('go-ranking', $event)"
        :game_id="rec.game_id"
        :cover="rec.cover"
        :title="rec.title"
        :description="rec.description"
      />
    </v-flex>
  </v-layout>
</template>

<script>
  import Recommendation from '@/components/molecules/Recommendation';

  export default {
    components: { Recommendation },
    props: ['recommendations'],
  };
</script>
